import { render, staticRenderFns } from "./BaseCleaners.vue?vue&type=template&id=6d302fdf"
import script from "./BaseCleaners.vue?vue&type=script&lang=js"
export * from "./BaseCleaners.vue?vue&type=script&lang=js"
import style0 from "./BaseCleaners.vue?vue&type=style&index=0&id=6d302fdf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports